export const passwordChannels = {
  Back: 'Voltar',
  'We will send you a verification code to confirm your identity':
    'Enviaremos um código de verificação para confirmar sua identidade',
  'How would you like to receive your code?': 'Como deseja receber seu código?',
  'Error!': 'Erro!',
  'Your account does not have any valid contact methods registered.':
    'Sua conta não possui nenhum meio de contato válido cadastrado.',
  'Password reset code sent successfully!':
    'Código de redefinição de senha enviado com sucesso!',
  'There was a problem sending your code':
    'Houve um problema ao enviar seu código',
};
